import { render, staticRenderFns } from "./AttributeTable.vue?vue&type=template&id=0c0b549b&"
import script from "./AttributeTable.vue?vue&type=script&lang=ts&"
export * from "./AttributeTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports